export const QUALITY = 'quality';
